import React, {useEffect, useState} from 'react';
import {Formik} from 'formik';
import Form_3View from './Form_3-view';
import {checkRequiredValues} from 'common/utils/form/checkRequiredValues';
import {useRouteMatch} from 'react-router-dom';
import {normalizeFormValues} from 'common/utils/form/normalizeFormValues';
import {pathnames as P} from 'common/constants/pathnames';
import SilentSubmitHandler from '../SilentSubmitHandler';
import ModalPreviewDocument from '../../../../common/components/ModalPreviewDocument';
import {
  buildingBuildTypeOptions,
  buildingElevatorOptions,
  buildingIntercomOptions,
  buildingLocationOptions,
  buildingMaintenanceOptions,
  buildingMatchingEnvironmentOptions,
  buildingOnPillarsOptions,
  buildingOuterLayerOptions,
  buildingParkingOptions,
  buildingPhysicalStateOptions,
  buildingPopulatedOptions,
  buildingRoofTypeOptions,
  buildingTypeIdOptions,
  houseFinishGradeOptions,
  houseMaintenanceStatusOptions,
  houseMatchingBuildingOptions,
  houseParkingTypeOptions,
  housePhysicalStateOptions,
  houseRoofAccessOptions,
  houseSecureRoomOptions,
  houseStorageTypeOptions,
  houseYardAffectiveOptions,
  houseYardTypeOptions,
  landTopographyOptions,
  presentorAssociationOptions,
  presentorGenderOptions,
  presentorIdTypeOptions,
  propertyPopulatedOptions,
  visitorJobOptions,
} from '../../../../common/constants/options';
import {fileTypeId as T} from '../../constants/fileTypeId';
import {propertyTypesGroups as PT} from '../../constants/propertyTypesGroups';
import {isFileUploaded} from '../../utils/isFileUploaded';
import {uploadingProgress} from '../../../../common/utils/form/uploadingProgress';
import ButtonSubmitForm from '../ButtonSubmitForm';
import SpinnerContainer from '../../../../common/components/SpinnerContainer';
import {
  filterFileListByFileTypeId,
  getSharedAndPrivateFiles,
  getFileFolderID
} from '../../utils/fileHelpers';
import {getOption} from "../../utils/getOption";

const Form_3 = ({
                  submitStep,
                  stepData,
                  uploadFile,
                  getShumaStepStatus,
                  getStepData,
                  showGlobalErrorMessage,
                  shumaTypeID,
                  propertyTypeID,
                  getFirmUsers,
                  users,
                  getFileList,
                  filesListData
                }) => {
  const [reinit, setReinit] = useState(true);
  const [progress, setProgress] = useState(0);
  const [showUploadingFilePopUp, setShowUploadingFilePopUp] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => getFirmUsers(), []);

  const {
    fileList,
    presentorGender,
    propertyPopulated,
    visitDate,
    officialDate,
    visitorID,
    cityName,
    streetName,
    floor,
    landTopography,
    attached,
    buildingElevator,
    buildingIntercom,
    buildingOnPillars,
    buildingParking,
    buildingMaintenance,
    buildingPhysicalState,
    buildingLocation,
    housePhysicalState,
    houseFinishGrade,
    houseMaintenanceStatus,
    houseAirDirectionNorth,
    houseAirDirectionSouth,
    houseAirDirectionEast,
    houseAirDirectionWest,
    houseAirDirectionNorthEast,
    houseAirDirectionNorthWest,
    houseAirDirectionSouthEast,
    houseAirDirectionSouthWest,
    houseYard,
    houseStorage,
    houseOther,
    houseParking,
    houseRoof,
    houseYardAffective,
    houseYardType,
    houseYardArea,
    houseParkingType,
    houseStorageType,
    houseRoofAccess,
    visitorJob,
    presentorIdNumber,
    presentorAssociation,
    houseSecureRoom,
    buildingRoofType,
    buildingPopulated,
    buildingApartmentPerFloor,
    buildingEntranceCount,
    buildingOuterLayer,
    buildingOuterLayerText,
    buildingBuildType,
    buildingBuildTypeText,
    buildingMatchingEnvironment,
    houseMatchingBuilding,
    presentorTypeID,
    buildingTypeID,
    propertyOnPillars,
    propertyRoofType,
    propertyOuterLayer,
    propertyBuildType,
    isVisitDateOfficial,
    ...rest
  } = stepData;

  const [previousBuildingElevator] = (buildingElevator || buildingElevator === 0) ? buildingElevatorOptions.filter(opt => opt.value === buildingElevator) : [];

  const initialValues = {
    visitDate: (visitDate) ? new Date(visitDate) : null,
    officialDate: (officialDate) ? new Date(officialDate) : null,
    isVisitDateOfficial: Boolean(isVisitDateOfficial) || false,
    visitorID: getOption(users, visitorID),
    visitorJob: getOption(visitorJobOptions, visitorJob),
    presentorFirstName: '',
    presentorLastName: '',
    presentorGender: getOption(presentorGenderOptions, presentorGender),
    propertyPopulated: getOption(propertyPopulatedOptions, propertyPopulated),
    landTopography: getOption(landTopographyOptions, landTopography),
    buildingFloorsCount: '',
    buildingLocation: getOption(buildingLocationOptions, buildingLocation),
    buildingOnPillars: getOption(buildingOnPillarsOptions, buildingOnPillars),
    buildingParking: getOption(buildingParkingOptions, buildingParking),
    buildingMaintenance: getOption(buildingMaintenanceOptions, buildingMaintenance),
    buildingPhysicalState: getOption(buildingPhysicalStateOptions, buildingPhysicalState),
    buildingElevator: (buildingElevator || buildingElevator === 0) ? previousBuildingElevator : null,
    buildingIntercom: getOption(buildingIntercomOptions, buildingIntercom),
    houseRoomCount: '',
    houseExistingArea: '',
    houseFunctionalDivide: '',
    housePhysicalState: getOption(housePhysicalStateOptions, housePhysicalState),
    houseFinishGrade: getOption(houseFinishGradeOptions, houseFinishGrade),
    houseMaintenanceStatus: getOption(houseMaintenanceStatusOptions, houseMaintenanceStatus),
    houseMaintenanceStatusText: '',
    houseBalconyOpenArea: '',
    houseBalconyClosedArea: '',
    houseAirDirectionNorth: Boolean(houseAirDirectionNorth) || null,
    houseAirDirectionSouth: Boolean(houseAirDirectionSouth) || null,
    houseAirDirectionEast: Boolean(houseAirDirectionEast) || null,
    houseAirDirectionWest: Boolean(houseAirDirectionWest) || null,
    houseAirDirectionNorthEast: Boolean(houseAirDirectionNorthEast) || null,
    houseAirDirectionNorthWest: Boolean(houseAirDirectionNorthWest) || null,
    houseAirDirectionSouthEast: Boolean(houseAirDirectionSouthEast) || null,
    houseAirDirectionSouthWest: Boolean(houseAirDirectionSouthWest) || null,
    houseYard: Boolean(houseYard) || null,
    houseStorage: Boolean(houseStorage) || null,
    houseOther: Boolean(houseOther) || null,
    houseParking: Boolean(houseParking) || null,
    houseRoof: Boolean(houseRoof) || null,
    houseYardAffective: getOption(houseYardAffectiveOptions, houseYardAffective),
    houseYardType: getOption(houseYardTypeOptions, houseYardType),
    houseYardArea: houseYardArea || '',
    houseParkingType: getOption(houseParkingTypeOptions, houseParkingType),
    houseStorageArea: '',
    houseStorageType: getOption(houseStorageTypeOptions, houseStorageType),
    houseRoofArea: '',
    houseRoofAccess: getOption(houseRoofAccessOptions, houseRoofAccess),
    houseOtherText: '',
    presentorIdNumber: presentorIdNumber || '',
    presentorAssociation: getOption(presentorAssociationOptions, presentorAssociation),
    houseSecureRoom: getOption(houseSecureRoomOptions, houseSecureRoom),
    buildingRoofType: getOption(buildingRoofTypeOptions, buildingRoofType),
    buildingPopulated: getOption(buildingPopulatedOptions, buildingPopulated),
    buildingApartmentPerFloor: buildingApartmentPerFloor || '',
    buildingEntranceCount: buildingEntranceCount || '',
    buildingOuterLayer: getOption(buildingOuterLayerOptions, buildingOuterLayer),
    buildingBuildType: getOption(buildingBuildTypeOptions, buildingBuildType),
    buildingOuterLayerText: buildingOuterLayerText || '',
    buildingBuildTypeText: buildingBuildTypeText || '',
    buildingMatchingEnvironment: getOption(buildingMatchingEnvironmentOptions, buildingMatchingEnvironment),
    buildingMatchingEnvironmentText: '',
    houseMatchingBuilding: getOption(houseMatchingBuildingOptions, houseMatchingBuilding),
    houseMatchingBuildingText: '',
    presentorIdType: getOption(presentorIdTypeOptions, presentorTypeID),
    buildingTypeId: getOption(buildingTypeIdOptions, buildingTypeID),
    structure: '',
    buildingPhysicalStateDesc: '',
    buildPercentage: '',
    houseFloorInBuilding: '',
    houseFinishGradeDesc: '',
    propertyPopulatedNotes: '',
    buildingAge: '',
    buildingTenantsLicenseCount: '',
    buildingTenantsRegisteredCount: '',
    buildingOnPillarsOtherText: '',
    propertyAge: '',
    propertyFloorsCount: '',
    propertyOnPillars: getOption(buildingOnPillarsOptions, propertyOnPillars),
    propertyRoofType: getOption(buildingRoofTypeOptions, propertyRoofType),
    propertyOuterLayer: getOption(buildingOuterLayerOptions, propertyOuterLayer),
    propertyBuildType: getOption(buildingBuildTypeOptions, propertyBuildType),
    propertyOnPillarsOtherText: '',
    propertyOuterLayerText: '',
    propertyBuildTypeText: '',
    apartmentsNumberInBuilding: '',
    apartmentsNumberAtGroundFloor: '',
    propertyGeneralNotes: '',

    fileType10Switch: false,
    fileType33Switch: false,

    ...rest
  };

  const {params: {shumaId, formId: stepId}} = useRouteMatch(P.INSPECTION_AND_FORM_IDS);

  const validate = values => {
    const {
      other,
      attachedText,
      presentorFirstName,
      presentorLastName,
      presentorGender,
      buildingLocation,
      houseMaintenanceStatusText,
      houseBalconyOpenArea,
      houseBalconyClosedArea,
      buildingRoofType,
      buildingPopulated,
      buildingApartmentPerFloor,
      buildingEntranceCount,
      buildingOuterLayer,
      buildingBuildType,
      presentorIdNumber,
      buildingMatchingEnvironment,
      buildingMatchingEnvironmentText,
      houseMatchingBuilding,
      houseMatchingBuildingText,
      landTopography,
      houseExistingArea,
      buildingTypeId,
      structure,
      buildingPhysicalStateDesc,
      buildPercentage,
      houseFloorInBuilding,
      houseFinishGradeDesc,
      propertyPopulatedNotes,
      buildingAge,
      buildingTenantsLicenseCount,
      buildingTenantsRegisteredCount,
      buildingOnPillarsOtherText,
      propertyAge,
      propertyFloorsCount,
      propertyOnPillars,
      propertyRoofType,
      propertyOuterLayer,
      propertyBuildType,
      propertyOnPillarsOtherText,
      propertyOuterLayerText,
      propertyBuildTypeText,
      apartmentsNumberInBuilding,
      apartmentsNumberAtGroundFloor,
      isVisitDateOfficial,
      buildingIntercom,
      propertyGeneralNotes,
      fileType10Switch,
      fileType33Switch,
      ...rest
    } = values;

    switch (shumaTypeID) {
      case 1:
        if (values.houseMaintenanceStatus && values.houseMaintenanceStatus.value === 2) {
          return checkRequiredValues({
            houseExistingArea,
            houseMaintenanceStatusText,
            buildingIntercom,
            ...rest
          }, {});
        } else {
          return checkRequiredValues({
            buildingIntercom,
            ...rest
          }, {});
        }
      case 2:
        if (values.houseMaintenanceStatus && values.houseMaintenanceStatus.value === 2) {
          return checkRequiredValues({
            buildingRoofType,
            buildingPopulated,
            buildingApartmentPerFloor,
            buildingEntranceCount,
            buildingOuterLayer,
            buildingBuildType,
            houseMaintenanceStatusText,
            buildingIntercom,
            ...rest
          }, {});
        } else {
          return checkRequiredValues({
            buildingRoofType,
            buildingPopulated,
            buildingApartmentPerFloor,
            buildingEntranceCount,
            buildingOuterLayer,
            buildingBuildType,
            buildingIntercom,
            ...rest
          }, {});
        }
      case 3:
      case 4:
        if (values.houseMaintenanceStatus && values.houseMaintenanceStatus.value === 2) {
          return checkRequiredValues({
            buildingRoofType,
            buildingPopulated,
            buildingApartmentPerFloor,
            buildingEntranceCount,
            buildingOuterLayer,
            buildingBuildType,
            houseMaintenanceStatusText,
            buildingMatchingEnvironmentText,
            houseMatchingBuildingText,
            buildingIntercom,
            ...rest
          }, {})
        } else {
          return checkRequiredValues({
            buildingRoofType,
            buildingPopulated,
            buildingApartmentPerFloor,
            buildingEntranceCount,
            buildingOuterLayer,
            buildingBuildType,
            buildingMatchingEnvironmentText,
            houseMatchingBuildingText,
            buildingIntercom,
            ...rest
          }, {})
        }
      default:
        return {}
    }
  };

  const submitWithoutFormReinitialization = values => {
    const {
      visitDate,
      officialDate,
      isVisitDateOfficial,
      visitorID,
      visitorJob,
      presentorFirstName,
      presentorLastName,
      presentorGender,
      propertyPopulated,
      landTopography,
      buildingOnPillars,
      buildingParking,
      buildingMaintenance,
      buildingPhysicalState,
      buildingFloorsCount,
      buildingLocation,
      buildingElevator,
      buildingIntercom,
      houseRoomCount,
      houseExistingArea,
      houseFunctionalDivide,
      housePhysicalState,
      houseFinishGrade,
      houseMaintenanceStatus,
      houseMaintenanceStatusText,
      houseBalconyOpenArea,
      houseBalconyClosedArea,
      houseAirDirectionNorth,
      houseAirDirectionSouth,
      houseAirDirectionEast,
      houseAirDirectionWest,
      houseAirDirectionNorthEast,
      houseAirDirectionNorthWest,
      houseAirDirectionSouthEast,
      houseAirDirectionSouthWest,
      houseYard,
      houseStorage,
      houseOther,
      houseParking,
      houseRoof,
      houseYardAffective,
      houseYardType,
      houseYardArea,
      houseParkingType,
      houseStorageArea,
      houseStorageType,
      houseRoofArea,
      houseRoofAccess,
      houseOtherText,
      presentorIdNumber,
      presentorAssociation,
      houseSecureRoom,
      buildingRoofType,
      buildingPopulated,
      buildingApartmentPerFloor,
      buildingEntranceCount,
      buildingOuterLayer,
      buildingOuterLayerText,
      buildingBuildType,
      buildingBuildTypeText,
      buildingMatchingEnvironment,
      buildingMatchingEnvironmentText,
      houseMatchingBuilding,
      houseMatchingBuildingText,
      presentorIdType,
      buildingTypeId,
      structure,
      buildingPhysicalStateDesc,
      buildPercentage,
      houseFloorInBuilding,
      houseFinishGradeDesc,
      propertyPopulatedNotes,
      buildingAge,
      buildingTenantsLicenseCount,
      buildingTenantsRegisteredCount,
      buildingOnPillarsOtherText,
      propertyAge,
      propertyFloorsCount,
      propertyOnPillars,
      propertyRoofType,
      propertyOuterLayer,
      propertyBuildType,
      propertyOnPillarsOtherText,
      propertyOuterLayerText,
      propertyBuildTypeText,
      apartmentsNumberInBuilding,
      apartmentsNumberAtGroundFloor,
      propertyGeneralNotes
    } = normalizeFormValues(values);
    const data = {
      shumaID: shumaId,
      shumaTypeID,
      shumaReason: 1,
      visitDate,
      officialDate,
      isVisitDateOfficial,
      visitorID,
      visitorJob,
      presentorFirstName,
      presentorLastName,
      presentorGender,
      propertyPopulated,
      landTopography,
      buildingOnPillars,
      buildingParking,
      buildingMaintenance,
      buildingPhysicalState,
      buildingFloorsCount,
      buildingLocation,
      buildingElevator,
      buildingIntercom,
      houseRoomCount,
      houseExistingArea,
      houseFunctionalDivide,
      housePhysicalState,
      houseFinishGrade,
      houseMaintenanceStatus,
      houseMaintenanceStatusText,
      houseBalconyOpenArea,
      houseBalconyClosedArea,
      houseAirDirectionNorth,
      houseAirDirectionSouth,
      houseAirDirectionEast,
      houseAirDirectionWest,
      houseAirDirectionNorthEast,
      houseAirDirectionNorthWest,
      houseAirDirectionSouthEast,
      houseAirDirectionSouthWest,
      houseYard,
      houseStorage,
      houseOther,
      houseParking,
      houseRoof,
      houseYardAffective,
      houseYardType,
      houseYardArea,
      houseParkingType,
      houseStorageArea,
      houseStorageType,
      houseRoofArea,
      houseRoofAccess,
      houseOtherText,
      presentorIdNumber,
      presentorAssociation,
      houseSecureRoom,
      buildingRoofType,
      buildingPopulated,
      buildingApartmentPerFloor,
      buildingEntranceCount,
      buildingOuterLayer,
      buildingOuterLayerText,
      buildingBuildType,
      buildingBuildTypeText,
      buildingMatchingEnvironment,
      buildingMatchingEnvironmentText,
      houseMatchingBuilding,
      houseMatchingBuildingText,
      presentorIdType,
      buildingTypeId,
      structure,
      buildingPhysicalStateDesc,
      buildPercentage,
      houseFloorInBuilding,
      houseFinishGradeDesc,
      propertyPopulatedNotes,
      buildingAge,
      buildingTenantsLicenseCount,
      buildingTenantsRegisteredCount,
      buildingOnPillarsOtherText,
      propertyAge,
      propertyFloorsCount,
      propertyOnPillars,
      propertyRoofType,
      propertyOuterLayer,
      propertyBuildType,
      propertyOnPillarsOtherText,
      propertyOuterLayerText,
      propertyBuildTypeText,
      apartmentsNumberInBuilding,
      apartmentsNumberAtGroundFloor,
      propertyGeneralNotes
    };
    setReinit(false);  //https://github.com/formium/formik/issues/2369
    return submitStep({step: 3, data})
      .then(() => setReinit(true));
  };

  const handleDataSubmit = (values, shumaId, dirty) => {
    if (dirty) {
      submitWithoutFormReinitialization(values)
        .then(() => getShumaStepStatus({shumaId, resetValues: false}))
        .catch((err) => showGlobalErrorMessage(err.message));
    }
  };

  const buildingFacadeFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.BUILDING_FACADE});
  const visitDatePhotoFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.PHOTOS_VISIT_DATE});
  const propertyDrawingFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.PROPERTY_DRAWING});

  useEffect(() => {
    getFileList({shumaId})
  }, []);

  const getAddress = () => {
    const {cityName, streetName, houseNumber} = stepData;

    return (Boolean(cityName) && Boolean(streetName) && Boolean(houseNumber))
      ? `${houseNumber} ${streetName} ${cityName}`
      : null;
  };

  const fileTypeIds = {
    buildingFacade: T.BUILDING_FACADE,
    photosVisitDate: T.PHOTOS_VISIT_DATE,
    propertyDrawing: T.PROPERTY_DRAWING,
  };

  const handleFileUpload = formikProps => fileTypeId => (file, payload) => {
    setShowUploadingFilePopUp(true);
    submitFiles(fileTypeId)(file, payload)
      .then(() => uploadingProgress(setProgress))
      .then(() => submitWithoutFormReinitialization(formikProps.values))
      .then(() => getShumaStepStatus({shumaId, resetValues: false}))
      .finally(() => {
        setShowUploadingFilePopUp(false);
        getFileList({shumaId});
        getStepData({shumaId, stepId});
      });
  };

  const submitFiles = fileTypeId => (fileToSave, payload) => {
    return uploadFile({shumaId, filename: fileToSave.name, fileTypeId, fileToSave}, payload);
  };

  const handleDataSubmitForPreview = (values, shumaId, dirty) => {
    if (dirty) {
      submitWithoutFormReinitialization(values)
        .then(() => getStepData({shumaId, stepId}))
        .then(() => getShumaStepStatus({shumaId, resetValues: false}))
        .catch((err) => showGlobalErrorMessage(err.message));
    }
  };

  const handleDataSubmitForSave = (values, shumaId, dirty) => {
    if (dirty) {
      setLoading(true);
      submitWithoutFormReinitialization(values)
        .then(() => getStepData({shumaId, stepId}))
        .then(() => getShumaStepStatus({shumaId, resetValues: false}))
        .catch((err) => showGlobalErrorMessage(err.message))
        .finally(() => setLoading(false));
    }
  };

  const handleSubmitForSharedFiles = formikProps => {
    Promise.resolve()
      .then(() => {
        submitWithoutFormReinitialization(formikProps.values);
      })
      .then(() => {
        getFileList({shumaId})
      })
      .then(() => getShumaStepStatus({shumaId, resetValues: false}));
  };

  const getFileSelectOptions = formikProps => {
    const filteredSharedFileID10 = filterFileListByFileTypeId(fileList, fileTypeIds.buildingFacade);
    const filteredSharedFileID11 = filterFileListByFileTypeId(fileList, fileTypeIds.photosVisitDate);
    const filteredSharedFileID33 = filterFileListByFileTypeId(fileList, fileTypeIds.propertyDrawing);
    const onSubmit = () => handleSubmitForSharedFiles(formikProps);

    return {
      buildingFacade: {
        type: getSharedAndPrivateFiles(filteredSharedFileID10),
        fileTypeID: fileTypeIds.buildingFacade,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.buildingFacade),
      },
      photosVisitDate: {
        type: getSharedAndPrivateFiles(filteredSharedFileID11),
        fileTypeID: fileTypeIds.photosVisitDate,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.photosVisitDate),
      },
      propertyDrawing: {
        type: getSharedAndPrivateFiles(filteredSharedFileID33),
        fileTypeID: fileTypeIds.propertyDrawing,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.propertyDrawing),
      },
    };
  };

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={() => {
      }}
      enableReinitialize={reinit}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {(formikProps) => (
        <>
          <SilentSubmitHandler
            onSubmit={handleDataSubmit}
            values={formikProps.values}
            shumaId={shumaId}
            dirty={formikProps.dirty}
          />
          <ButtonSubmitForm
            onClick={() => {
              handleDataSubmitForSave(
                formikProps.values,
                shumaId,
                formikProps.dirty
              )
            }}
            disabled={!formikProps.dirty}
          />
          <ModalPreviewDocument
            submitOnOpen={() => {
              handleDataSubmitForPreview(
                formikProps.values,
                shumaId,
                formikProps.dirty
              )
            }}
          />
          {loading ? <SpinnerContainer/> : (
            <Form_3View
              {...formikProps}
              shumaID={shumaId}
              stepID={stepId}
              prevPagePath={P.GET_FORM_BY_ID_AND_STEP(shumaId, 4)}
              nextPagePath={P.GET_FORM_BY_ID_AND_STEP(shumaId, 1)}
              options={{
                presentorGenderOptions,
                propertyPopulatedOptions,
                landTopographyOptions,
                buildingElevatorOptions,
                buildingIntercomOptions,
                buildingLocationOptions,
                buildingOnPillarsOptions,
                buildingParkingOptions,
                buildingMaintenanceOptions,
                buildingPhysicalStateOptions,
                housePhysicalStateOptions,
                houseFinishGradeOptions,
                houseMaintenanceStatusOptions,
                houseYardAffectiveOptions,
                houseYardTypeOptions,
                houseParkingTypeOptions,
                houseStorageTypeOptions,
                houseRoofAccessOptions,
                visitorJobOptions,
                presentorAssociationOptions,
                houseSecureRoomOptions,
                buildingRoofTypeOptions,
                buildingPopulatedOptions,
                buildingOuterLayerOptions,
                buildingBuildTypeOptions,
                buildingMatchingEnvironmentOptions,
                houseMatchingBuildingOptions,
                presentorIdTypeOptions,
                buildingTypeIdOptions,
                users
              }}
              mapPosition={getAddress()}
              onFileSelected={handleFileUpload(formikProps)}
              fileTypeIds={fileTypeIds}
              fileUploaded={{
                buildingFacadeFileUploaded,
                visitDatePhotoFileUploaded,
                propertyDrawingFileUploaded,
              }}
              progress={progress}
              showUploadingFilePopUp={showUploadingFilePopUp}
              filesListData={filesListData ?? []}
              shumaTypeID={shumaTypeID}
              propertyTypes={{
                isGroundOrLot: PT.GROUND_OR_LOT.includes(propertyTypeID),
                isLot: PT.LOT.includes(propertyTypeID),
                isGround: PT.GROUND.includes(propertyTypeID),
              }}
              fileSelectOptions={getFileSelectOptions(formikProps)}
            />
          )}
        </>
      )}
    </Formik>
  );
};

export default Form_3;